import tasksData from '@/mockData/tasks.json'
import ProjectsService from '@/services/api/projects.services'
import projectsServices from "@/services/api/projects.services";
import { buildTaskCommentFormData } from '@/helpers/taskComments'

const state = {
    tasks: tasksData,
    selectedUserTasks: [],
    currentUserTasks: [],
    myTasks: [],
    projectTasks: [],
    taskStatuses: [],
    preloader: false,
    projectSlug: {},
    taskSlug: {},
    clickedTaskProp: {},
    currentTask: {},
    currentTaskInfo: {},
    projectInfoStore: null,
    currentReleases: [],
    currentRelease: null,
    tasksForRelease: [],
    releaseOptions: null,
}

const mutations = {
    SET_CURRENT_TASK(state, payload) {
        state.currentTask = payload
    },

    SET_PROJECT_INFO_STORE(state, payload) {
        state.projectInfoStore = payload
    },

    SET_CURRENT_TASK_INFO(state, payload) {
        state.currentTaskInfo = payload
    },

    SET_TASKS_FOR_RELEASE(state, payload) {
        state.tasksForRelease = payload
    },


    SET_CURRENT_RELEASES(state, payload) {
        state.currentReleases = payload
    },

    SET_CURRENT_RELEASE(state, payload) {
        state.currentRelease = payload
    },

    SET_PRELOADER(state, payload) {
        state.preloader = payload
    },

    SET_CLICKED_TASK(state, payload) {
        state.clickedTaskProp = payload
    },
    ADD_TASK(state, payload) {
        state.tasks.push(payload)
    },
    CHANGE_TASK_STATUS(state, payload) {
        let idx = state.tasks.findIndex(item => item.id == payload.id)
        state.tasks[idx].status = payload.status
    },
    SET_SELECTED_USER_TASKS(state, payload) {
        state.selectedUserTasks = payload
    },
    SET_CURRENT_PROJECT_TASKS(state, payload) {
        state.projectTasks = payload;
    },
    SET_CURRENT_PROJECT_SLUG(state, payload) {
        state.projectSlug = payload;
    },
    SET_CURRENT_TASK_SLUG(state, payload) {
        state.taskSlug = payload;
    },
    SET_MY_TASKS(state, payload) {
        state.myTasks = payload
    },
    SET_TASKS_STATUSES(state, payload) {
        state.taskStatuses = payload
    },
    SET_CURRENT_USER_TASKS(state, payload) {
        state.currentUserTasks = payload
    },
    SET_RELEASE_OPTIONS(state, payload) {
        state.releaseOptions = payload
    },
}

const actions = {
    createTask(context, payload) {
        return new Promise((resolve, reject) => {
            projectsServices.post('createTask', {}, payload, {
                Accept: "*/*",
                "Content-Type": "multipart/form-data",
            })
                .then((response) => {
                    return resolve(response);
                }).catch((error) => reject(error))
        })
        // commit('ADD_TASK', form)
    },

    getCurrentTasks({ commit }, id) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('getCurrentTask', id).then((response) => {
                commit('SET_CURRENT_TASK', response.data.data)
                return resolve(response)
            }).catch((error) => reject(error))
        })
    },

    getCurrentReleases({ commit }, id) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('getReleases', id).then((response) => {
                commit('SET_CURRENT_RELEASES', response.data.data)
                return resolve(response)
            }).catch((error) => reject(error))
        })
    },
    getReleaseOptions({ commit }, id) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('getReleaseOptions', id).then((response) => {
                commit('SET_RELEASE_OPTIONS', response.data.data)
                return resolve(response)
            }).catch((error) => reject(error))
        })
    },

    getTasksForRelease({ commit }, id) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('getTasksForRelease', id).then((response) => {
                commit('SET_TASKS_FOR_RELEASE', response.data.data)
                return resolve(response)
            }).catch((error) => reject(error))
        })
    },

    getCurrentTasksByTag({ commit }, id) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('getCurrentTaskByTag', id).then((response) => {
                commit('SET_CURRENT_TASK', response.data.data)
                return resolve(response)
            }).catch((error) => reject(error))
        })
    },

    getCurrentTasksInfo({ commit }, id) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('getCurrentTaskInfo', id).then((response) => {
                commit('SET_CURRENT_TASK_INFO', response.data.data)
                return resolve(response)
            }).catch((error) => reject(error))
        })
    },

    setProjectInfo(context, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.addProjectInfo(payload.slug, payload.info)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    getProjectTasks({ commit }, id) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('projectTasks', id).then((response) => {
                commit('SET_CURRENT_PROJECT_TASKS', response.data.data)
                return resolve(response)
            }).catch((error) => reject(error))
        })
    },
    
getProjectTasksParent({ commit }, { id, activeStatuses }) {
  return new Promise((resolve, reject) => {
      const statusIds = (activeStatuses || []).map((x) => Number(x)).filter((n) => !Number.isNaN(n))
      ProjectsService.get('projectTasksParent', { id, statusIds: statusIds.join(',') })
          .then((response) => {
              commit('SET_CURRENT_PROJECT_TASKS', response.data.data);
              resolve(response);
          })
          .catch((error) => reject(error));
  });
},



    getProjectSlug({ commit }, id) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('projectSlug', id).then((response) => {
                commit('SET_CURRENT_PROJECT_SLUG', response.data.data)
                return resolve(response)
            }).catch((error) => reject(error))
        })
    },

    getTaskSlug({ commit }, params) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('taskSlug', params)
                .then((response) => {
                    commit('SET_CURRENT_TASK_SLUG', response.data.data)
                    return resolve(response)
                })
                .catch(({ errors }) => reject(errors))
        })
    },

    getCurrentRelease({ commit }, params) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('getCurrentRelease', params)
                .then((response) => {
                    commit('SET_CURRENT_RELEASE', response.data.data)
                    return resolve(response)
                })
                .catch(({ errors }) => reject(errors))
        })
    },

    // deleteRelease({ commit }, params) {
    //     return new Promise((resolve, reject) => {
    //         ProjectsService.delete('deleteRelease', params)
    //             .then((response) => {
    //                 commit('SET_CURRENT_RELEASE', response.data.data)
    //                 return resolve(response)
    //             })
    //             .catch(({ errors }) => reject(errors))
    //     })
    // },

    getUserTasks({ commit }, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('userTasks', payload)
                .then((response) => {
                    commit('SET_SELECTED_USER_TASKS', response.data.data)

                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    getMyCurrentTasks({commit}) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('personalTasks')
                .then((response) => {
                    commit('SET_MY_TASKS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    getTaskStatuses({ commit }) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('taskStatuses')
                .then((response) => {
                    commit('SET_TASKS_STATUSES', response.data.data);
                    return resolve(response);
                })
            .catch((error) => reject(error))
        })
    },
    getCurrentUserTasks({ commit }, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('userTasks', payload)
                .then((response) => {
                    commit('SET_CURRENT_USER_TASKS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    getTodos({ commit }, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('todos', payload)
                .then((response) => {
                    commit('SET_CURRENT_USER_TASKS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    getComments(context, payload) {
        const taskId = typeof payload === 'object' ? (payload?.id ?? payload?.taskId) : payload
        return new Promise((resolve, reject) => {
            ProjectsService.getTaskComments(taskId)
                .then((response) => resolve(response))
                .catch((error) => reject(error))
        })
    },

  getCurrentProjects({ commit }) {
    return new Promise((resolve, reject) => {
      ProjectsService.get('projects')
        .then((response) => {
          commit('SET_CURRENT_USER_TASKS', response.data.data)
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },

  getCurrentProjectsActive({ commit }) {
    return new Promise((resolve, reject) => {
      ProjectsService.get('activeProjects')
        .then((response) => {
          commit('SET_CURRENT_USER_TASKS', response.data.data)
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },
    deleteTask(context, id) {
        return new Promise((resolve, reject) => {
            ProjectsService.delete('deleteTask', id)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    changeStatus(context, {id, payload}) {
        return new Promise((resolve, reject) => {
            projectsServices.put('changeTaskStatus', id, payload)
                .then((response) => {
                    return resolve(response);
                }).catch((error) => reject(error))
        })
    },

    changeOrder(context, { id, payload }) {
        return projectsServices.patchProjectStatusPosition(id, payload)
    },

    editTask(context, {id, payload}) {
        return new Promise((resolve, reject) => {
            const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData
            if (isFormData) {
                if (!payload.has('_method')) {
                    payload.append('_method', 'PUT')
                }
                ProjectsService.post('editTask', id, payload, {
                    Accept: "*/*",
                    "Content-Type": "multipart/form-data",
                })
                    .then((response) => {
                        return resolve(response)
                    })
                    .catch((error) => reject(error))
                return
            }
            ProjectsService.put('editTask', id, payload)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    editProject(context, {id, payload}) {
        return new Promise((resolve, reject) => {
            ProjectsService.put('editProject', id, payload)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    editComment(context, payload) {
        return new Promise((resolve, reject) => {
            const data = payload.content instanceof FormData
                ? payload.content
                : buildTaskCommentFormData(payload.content, payload.attachments || [])
            ProjectsService.editNewTaskComment(payload.taskId, payload.commentId, data)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    editTodo(context, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.editTodo(payload.taskId, payload.commentId,  payload.content)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    release(context, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.release(payload.projectId, payload.releaseId, payload.content)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    deleteComment(context, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.deleteNewTaskComment(payload.taskId, payload.commentId)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },



    deleteRelease(context, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.deleteRelease(payload.projectId, payload.releaseId)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    clearBoard(context, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.clearBoard(payload.project, payload.board)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },


    deleteTodo(context, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.deleteTodo(payload.taskId, payload.commentId)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    deleteTaskAttachment(context, { taskId, attachmentId }) {
        return new Promise((resolve, reject) => {
            ProjectsService.deleteTaskAttachment(taskId, attachmentId)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    addNewComment(context, payload) {
        return new Promise((resolve, reject) => {
            let data = payload.content
            if (!(data instanceof FormData)) {
                const content = typeof data === 'object' && data !== null && data.content !== undefined
                    ? data.content
                    : payload.content
                data = buildTaskCommentFormData(content, payload.attachments || [])
            }
            ProjectsService.addNewComment(payload.taskId, data)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    createRelease(context, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.createRelease(payload.projectId, payload.content)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    addTodo(context, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.addTodo(payload.taskId, payload.content)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    addNewTask({ commit }, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.createNewTask(payload)
                .then((response) => {
                    commit('SET_CURRENT_USER_TASKS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    addNewProject({ commit }, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.createNewProject(payload)
                .then((response) => {
                    commit('SET_CURRENT_USER_TASKS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
}

const getters = {
    getData: state => user => state.tasks.filter(item => item.workers.some(worker => worker === user)),
    getUserTasks: state => state.selectedUserTasks,
    getCurrentProjectTasks: state => state.projectTasks,
    getFilteredCurrentTasks: state => filters => Object.entries(filters).length == 0 ? state.projectTasks : state.projectTasks.filter(item => item.area.includes(filters.area) && item.type == filters.type && item.priority.includes(filters.priority) && item.product_type.includes(filters.productType)),
    getCurrentUserTasks: state => state.currentUserTasks,
    getMyTasks: state => state.myTasks,
    getTaskStatuses: state => state.taskStatuses,
    preloader: state => state.preloader,
    getProjectSlug: state => state.projectSlug,
    getClickedTaskProp: state => state.clickedTaskProp,
    getCurrentTask: state => state.currentTask,
    getCurrentTaskInfo: state => state.currentTaskInfo,
    getProjectInfoStore: state => state.projectInfoStore,
    getCurrentTaskUsers: state => state.currentTask.project.users.map(user => user.user_name),
    currentReleases: state => state.currentReleases,

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
